<style>
.fullArtboard {
    width: 100% !important;
}
</style>
<template>
    <div class="canvasBlock group row relative">
        <transition leave-active-class="animated fadeOut">
            <div class="loadingBlock" v-if="!loadingComplete">
                <div class="center-align-ab">
                    <center>
                        <FulfillingBouncingCircleSpinner
                            :animation-duration="2500"
                            :size="45"
                            :color="'#232F4B'">
                        </FulfillingBouncingCircleSpinner>
                    </center><br />
                    <span class="loadingText">{{ loadingStatus }}</span>
                </div>
            </div>
        </transition>

        <transition enter-active-class="animated fadeInDown">
            <div v-if="loadingComplete && $store.state.mode === 'editor'" class="secondary-nav primarybgdark m-b-20">
                <div class="btn-group m-b-10 m-r-5">
                    <button type="button" @mouseenter="setTooltip(9)" @mouseleave="setTooltip(9)" class="btn btn-success dropdown-toggle waves-effect waves-light" data-toggle="dropdown" aria-expanded="false"><i class="icon-plus m-r-5"></i> Add <span class="icon-arrow-down"></span></button>
                    <ul class="dropdown-menu" role="menu">
                        <li><a href="#" v-on:click.prevent="addElement({type: 'text'})">Text <span>(⌘ + 1)</span></a></li>
                        <li><a href="#" v-on:click.prevent="addElement({type: 'rect', custom: { name: 'New Rectangle' }})">Block <span>(⌘ + 2)</span></a></li>
                        <li><a href="#" v-on:click.prevent="addElement({type: 'ellipse', custom: { name: 'New Ellipse' }})">Ellipse <span>(⌘ + 3)</span></a></li>
                        <li><a href="#" v-on:click.prevent="addElement({type: 'triangle', custom: { name: 'New Triangle' }})">Triangle <span>(⌘ + 4)</span></a></li>
                        <li><a href="#" v-on:click.prevent="addElement({type: 'image'})">Image <span>(⌘ + 5)</span></a></li>
                        <li><a href="#" v-on:click.prevent="addElement({type: 'clipping-area', custom: { name: 'Clipping Area', type: 'clipping-mask' }})">Mask - Box <span>(⌘ + 6)</span></a></li>
                        <li><a href="#" v-on:click.prevent="addElement({type: 'round-clipping-area', custom: { name: 'Clipping Area', type: 'clipping-mask' }})">Mask - Circle <span>(⌘ + 7)</span></a></li>
                    </ul>
                </div>

                <div class="btn-group m-b-10 m-r-5">
                    <button type="button" class="btn primarybg dropdown-toggle waves-effect waves-light" data-toggle="dropdown" aria-expanded="false">Zoom: {{ zoom * 100 + '%' }} <span class="icon-arrow-down"></span></button>
                    <ul class="dropdown-menu" role="menu">
                        <li><a href="#" v-on:click.prevent="resizeCanvas(1)">100%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.9)">90%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.8)">80%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.7)">70%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.6)">60%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.5)">50%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.4)">40%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.3)">30%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.2)">20%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.1)">10%</a></li>
                    </ul>
                </div>

                <button class="btn primarybg hover m-b-10 m-r-5" @mouseenter="setTooltip(10)" @mouseleave="setTooltip(10)" v-on:click.prevent="removeElement()"><i class="icon-bin"></i></button>

                <div class="btn-group m-b-10 m-r-5">
                    <button class="btn primarybg hover" @mouseenter="setTooltip(0)" @mouseleave="setTooltip(0)" v-on:click.prevent="groupAlign('left')"><i class="icon-align-left"></i></button>
                    <button class="btn primarybg hover" @mouseenter="setTooltip(1)" @mouseleave="setTooltip(1)" v-on:click.prevent="groupAlign('center')"><i class="icon-align-center-horizontal"></i></button>
                    <button class="btn primarybg hover" @mouseenter="setTooltip(2)" @mouseleave="setTooltip(2)" v-on:click.prevent="groupAlign('right')"><i class="icon-align-right"></i></button>
                    <button class="btn primarybg hover" @mouseenter="setTooltip(3)" @mouseleave="setTooltip(3)" v-on:click.prevent="groupAlign('top')"><i class="icon-align-top"></i></button>
                    <button class="btn primarybg hover" @mouseenter="setTooltip(26)" @mouseleave="setTooltip(26)" v-on:click.prevent="groupAlign('vertical-center')"><i class="icon-align-center-vertical"></i></button>
                    <button class="btn primarybg hover" @mouseenter="setTooltip(4)" @mouseleave="setTooltip(4)" v-on:click.prevent="groupAlign('bottom')"><i class="icon-align-bottom"></i></button>
                </div>

                <div class="btn-group m-b-10 m-r-5">
                    <button class="btn primarybg hover" @mouseenter="setTooltip(27)" @mouseleave="setTooltip(27)" v-on:click.prevent="evenlySpace('horizontal')"><i class="icon-menu"></i></button>
                    <button class="btn primarybg hover" @mouseenter="setTooltip(28)" @mouseleave="setTooltip(28)" v-on:click.prevent="evenlySpace('vertical')"><i class="icon-more2"></i></button>
                </div>

                <div class="btn-group m-b-10 m-r-5">
                    <button class="btn primarybg hover" @mouseenter="setTooltip(29)" @mouseleave="setTooltip(29)" v-on:click.prevent="flipX(null)"><i class="icon-flip-horizontal"></i></button>
                    <button class="btn primarybg hover" @mouseenter="setTooltip(30)" @mouseleave="setTooltip(30)" v-on:click.prevent="flipY(null)"><i class="icon-flip-vertical"></i></button>
                </div>

                <div class="btn-group m-b-10 m-r-5">
                    <button class="btn primarybg hover" @mouseenter="setTooltip(5)" @mouseleave="setTooltip(5)" v-on:click.prevent="moveLayer(null, 'front')"><i class="icon-angle-double-up m-r-5"></i></button>
                    <button class="btn primarybg hover" @mouseenter="setTooltip(6)" @mouseleave="setTooltip(6)" v-on:click.prevent="moveLayer(null, 'forward')"><i class="icon-angle-up m-r-5"></i></button>
                    <button class="btn primarybg hover" @mouseenter="setTooltip(7)" @mouseleave="setTooltip(7)" v-on:click.prevent="moveLayer(null, 'backward')"><i class="icon-angle-down m-r-5"></i></button>
                    <button class="btn primarybg hover" @mouseenter="setTooltip(8)" @mouseleave="setTooltip(8)" v-on:click.prevent="moveLayer(null, 'back')"><i class="icon-angle-double-down m-r-5"></i></button>
                </div>

                <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutDown">
                    <p class="right primarytextlight" v-if="tooltip !== null">
                        {{ tooltip }}
                    </p>
                </transition>
            </div>
        </transition>

        <div class="col-sm-8 m-b-20 artboardWrapper" :class="{ fullArtboard: (displayType === 'preview'), artboard: true, 'designMode': displayType === 'designer', 'editMode': displayType === 'editor'}">
            <div class="containerWrapper">
                <canvas id="canvas" :width="productPixelWidth" :height="productPixelHeight" style="width: 100%; height: 635px; border:1px solid #BBB;" v-insert-message="exampleContent"></canvas>
            </div>
        </div>

        <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
            <div
            v-if="displayType !== 'preview'"
            v-show="$store.state.template.userversions === undefined || $store.state.template.userversions.data.length < 1 || $store.state.savedTemplate !== null || newTemplate === true || $store.state.mode === 'editor'"
            :class="{'designMode': displayType === 'designer', 'editMode': displayType === 'editor'}"
            class="panel-group panel-group-joined layers col-sm-4 right"
            id="accordion-test">
                <div class="noEdit m-b-20" v-if="noEditableLayers === true">
                    This template has no layers to edit, please proceed below.
                </div>

                <div class="panel panel-default" v-for="(shape, index) in canvasDataReverse" v-if="
                    shape.custom === undefined ||
                    (displayType === 'designer' && shape.type !== 'rect' && shape.type !== 'ellipse' && shape.type !== 'triangle' && shape.custom.editable === true) ||
                    (displayType === 'editor' && shape.custom !== undefined && shape.custom.name !== 'Trim Area' && shape.custom.name !== 'Safe Area')
                ">

                    <a v-show="loadingComplete" data-toggle="collapse" data-parent="#accordion-test" :href="['#collapse' + index]" @click="setActiveObject(index)" :class="{'confirmed': (shape.custom.confirmed === true)}" class="collapsed" aria-expanded="false">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <i class="icon-format m-r-5" v-if="shape.type === 'textbox'"></i>
                                <i class="icon-crop m-r-5" v-else-if="shape.custom.type === 'clipping-mask'"></i>
                                <i class="icon-shapes m-r-5" v-else-if="shape.type === 'rect'"></i>
                                <i class="icon-shapes m-r-5" v-else-if="shape.type === 'ellipse'"></i>
                                <i class="icon-shapes m-r-5" v-else-if="shape.type === 'triangle'"></i>
                                <i class="icon-image m-r-5" v-else-if="shape.type === 'image'"></i>

                                <span v-if="(shape.type === 'textbox') && (shape.custom && shape.custom.name === '')">{{ shape.text }}</span>
                                <span v-else-if="shape.custom">{{ shape.custom.name }}</span>
                                <span v-else-if="shape._originalElement && shape._originalElement.currentSrc">{{ shape._originalElement.currentSrc | shortenUrl }}</span>

                                <transition-group enter-active-class="animated fadeInRight" leave-active-class="animated fadeOut">
                                    <i key="1" class="icon-checkmark-circle right" v-if="shape.custom.confirmed === true"></i>
                                    <i key="2" class="icon-lock right" v-if="shape.custom.locked === true && displayType === 'editor'"></i>
                                    <i key="3" class="icon-no-edit right" v-if="shape.custom.editable === false && displayType === 'editor'"></i>
                                    <i key="4" class="icon-eye-blocked right" v-if="shape.visible === false"></i>
                                </transition-group>
                            </h4>
                        </div>
                    </a>

                    <div :id="['collapse' + index]" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">

                        <!-- ## Text Editing ## -->
                        <div class="panel-body" v-if="shape.type === 'textbox'">
                            <div v-if="displayType === 'editor'">
                                <div class="btn-group m-r-5">
                                    <editable @tooltip="setTooltip(11)" :shape="shape" :type="displayType" v-on:editable="editable(index)"></editable>
                                    <visible @tooltip="setTooltip(12)" :shape="shape" :type="displayType" v-on:visible="visible(index)"></visible>
                                    <lock @tooltip="setTooltip(13)" :shape="shape" :type="displayType" v-on:lock="lock(index)"></lock>
                                </div>
                                <copy @tooltip="setTooltip(21)" :shape="shape" :type="displayType" v-on:clone="clone()"></copy>

                                <br />
                                <div class="btn-group m-r-5">
                                    <italic @tooltip="setTooltip(14)" :shape="shape" v-on:italic="fontItalic(index)"></italic>
                                    <bold @tooltip="setTooltip(15)" :shape="shape" v-on:bold="fontBold(index)"></bold>
                                    <underline @tooltip="setTooltip(16)" :shape="shape" v-on:underline="fontUnderline(index)"></underline>
                                </div>

                                <div class="btn-group m-r-5">
                                    <alignLeft @tooltip="setTooltip(17)" :shape="shape" v-on:textAlign="textAlign(index, 'left')"></alignLeft>
                                    <alignCenter @tooltip="setTooltip(18)" :shape="shape" v-on:textAlign="textAlign(index, 'center')"></alignCenter>
                                    <alignRight @tooltip="setTooltip(19)" :shape="shape" v-on:textAlign="textAlign(index, 'right')"></alignRight>
                                    <alignJustify @tooltip="setTooltip(20)" :shape="shape" v-on:textAlign="textAlign(index, 'justify')"></alignJustify>
                                </div>

                                <div class="btn-group">
                                    <autoScale @tooltip="setTooltip(31)" :shape="shape" v-on:autoScale="autoScale(index)"></autoScale>
                                    <smallCaps @tooltip="setTooltip(32)" :shape="shape" v-on:smallCaps="smallCaps(index)"></smallCaps>
                                </div>
                            </div>
                            <ul class="m-b-0">
                                <li v-if="displayType === 'editor'">
                                    Name: <input type="text" @input="updateObject(index, $event)" v-model="shape.custom.name" />
                                </li>
                                <li>
                                    <div class="row">
                                        <div :class="{'col-md-12': (displayType !== 'designer'), 'col-md-8': (displayType === 'designer') }">
                                            {{ ($store.state.mode === 'editor') ? 'Default Text:' : '' }}
                                            <textarea @focus="$event.target.select()" @input="updateObject(index, $event)" v-model="shape.text" v-if="displayType === 'designer' && shape.custom.name.includes('Address')"></textarea>
                                            <input @focus="$event.target.select()" type="text" @input="updateObject(index, $event)" v-model="shape.text" v-else />
                                        </div>
                                        <div class="col-md-4" v-if="displayType === 'designer' || ($store.state.mode === 'editor' && shape.custom.autoscale)">
                                            <button :class="{'confirmed': shape.custom.confirmed}" class="btn confirmBtn btn-block m-b-5 m-t-5" v-if="displayType === 'designer'" @click="confirmEdit(index)">{{ (shape.custom.confirmed) ? 'Confirmed' : 'Confirm' }}</button>
                                            {{ ($store.state.mode === 'editor' && shape.custom.autoscale) ? 'Max Width' : '' }}
                                            <input type="text" :disabled="shape.custom.autoscale" @input="updateObject(index, $event)" v-model="shape.custom.maxWidth" v-if="$store.state.mode === 'editor' && shape.custom.autoscale" />
                                        </div>
                                    </div>
                                    <div class="row" v-if="$store.state.mode === 'editor' && shape.custom.autoscale">
                                        <div class="col-md-12">
                                            <small>* To set the autoscale width, please toggle autoscale off and on.</small>
                                        </div>
                                    </div>
                                </li>
                                <li class="left charSettings" v-if="displayType === 'editor'">
                                    Format:
                                    <select v-model="shape.custom.mask" @change="updateObject(index, $event)">
                                        <option :value="i" v-for="(mask, i) in formatMasks">{{ mask.name }}</option>
                                    </select>
                                </li>
                                <li class="left charSettings m-r-0" v-if="displayType === 'editor'">
                                    Data Attribute:
                                    <select v-model="shape.custom.data_attribute" @change="updateObject(index, $event)">
                                        <option value="">No Data Injection</option>
                                        <option value="#" disabled="disabled"># Standard Data Attributes ----------</option>
                                        <option :value="(value === '# Vendor Data Attributes ----------') ? '#' : value" :disabled="value === '# Vendor Data Attributes ----------'" v-for="value in dataAttributes">{{ value.replace('vendor.','') | underlineSpace | capitalize }}</option>
                                    </select>
                                </li>
                                <li class="left charSettings" v-if="displayType === 'editor'">
                                    <small class="right"><a href="https://fonts.google.com/" target="_blank">Google Fonts</a></small>
                                    Font:
                                    <select v-model="shape.fontFamily" @change="updateObject(index, $event)">
                                        <option v-for="(font, i) in $store.state.fonts" :data-index="i" :disabled="font.name === 'Custom Fonts:' || font.name === 'Google Fonts:' || font.name === '-----------------------' || font.name === ''">
                                            {{ font.name }}
                                        </option>
                                    </select>
                                </li>
                                <li v-if="displayType === 'editor'" class="left charSettings m-r-0">Limit Characters: (0 = unlimited) <input type="number" step="1" @input="updateObject(index, $event)" v-model="shape.custom.charLimit" /></li>
                                <li v-if="displayType === 'editor'" class="left charSettings split">Size: <input type="number" step="1" @input="updateObject(index, $event)" v-model="shape.custom.fontSize" /></li>
                                <li v-if="displayType === 'editor'" class="left charSettings split">Units:
                                    <select @change="updateObject(index, $event)" v-model="shape.custom.fontUnits" :disabled="shape.custom.autoscale">
                                        <option value="px">px</option>
                                        <option value="pt" v-if="!shape.custom.autoscale">pt</option>
                                        <option value="pc" v-if="!shape.custom.autoscale">pc</option>
                                        <option value="em" v-if="!shape.custom.autoscale">em</option>
                                        <option value="in" v-if="!shape.custom.autoscale">in</option>
                                        <option value="mm" v-if="!shape.custom.autoscale">mm</option>
                                        <option value="cm" v-if="!shape.custom.autoscale">cm</option>
                                    </select>
                                </li>
                                <li v-if="displayType === 'editor'" class="left charSettings split">Leading: <input type="number" step="0.10" @change="updateObject(index, $event)" v-model="shape.lineHeight" /></li>
                                <li v-if="displayType === 'editor'" class="left charSettings split m-r-0">Kerning: <input type="number" step="1" @change="updateObject(index, $event)" v-model="shape.charSpacing" /></li>
                                <li v-if="displayType === 'editor'" class="left">Fill Color:<br /><input type="color" @change="updateObject(index, $event)" v-model="shape.fill"  style="width:50px;"></li>
                            </ul>
                        </div>

                        <!-- ## Rect / Ellipse / Triangle - Editing ## -->
                        <div class="panel-body" v-if="displayType === 'editor' && (shape.type === 'rect' || shape.type === 'ellipse' || shape.type === 'triangle')">
                            <div class="btn-group m-r-5">
                                <editable @tooltip="setTooltip(11)" :shape="shape" :type="displayType" v-on:editable="editable(index)" v-if="shape.custom.type !== 'clipping-mask'"></editable>
                                <visible @tooltip="setTooltip(12)" :shape="shape" :type="displayType" v-on:visible="visible(index)"></visible>
                                <lock @tooltip="setTooltip(13)" :shape="shape" :type="displayType" v-on:lock="lock(index)"></lock>
                            </div>

                            <copy @tooltip="setTooltip(21)" :shape="shape" :type="displayType" v-on:clone="clone()" v-if="shape.custom.type !== 'clipping-mask'" ></copy>

                            <ul>
                                <li>Name: <input type="text" @input="updateObject(index, $event)" v-model="shape.custom.name" /></li>
                                <li v-if="shape.custom.type !== 'clipping-mask'">Stroke: <input type="number" step="1" @input="updateObject(index, $event)" v-model.number="shape.strokeWidth" /></li>
                                <li v-if="shape.custom.type !== 'clipping-mask'" class="colorSettings left">Fill Color:<br /><input type="color" @change="updateObject(index, $event)" v-model="shape.fill" /></li>
        						<transition enter-active-class="animated fadeInLeft" leave-active-class="animated fadeOutLeft">
                            		<li v-if="shape.custom.type !== 'clipping-mask' && shape.strokeWidth > 0" class="colorSettings left">Stroke Color:<br /><input type="color" @change="updateObject(index, $event)" v-model="shape.stroke" /></li>
        						</transition>
                            </ul>

                            <button :class="{'confirmed': shape.custom.confirmed}" class="btn confirmBtn btn-block m-b-5 m-t-5" v-if="displayType === 'designer'" @click="confirmEdit(index)">{{ (shape.custom.confirmed) ? 'Confirmed' : 'Confirm' }}</button>
                        </div>

                        <!-- ## Image Editing ## -->
                        <div class="panel-body" v-if="shape.type === 'image'">
                            <div class="btn-group m-r-5">
                                <editable @tooltip="setTooltip(11)" :shape="shape" :type="displayType" v-on:editable="editable(index)" v-if="shape.custom.type !== 'clipping-mask'"></editable>
                                <visible @tooltip="setTooltip(12)" :shape="shape" :type="displayType" v-on:visible="visible(index)"></visible>
                                <lock @tooltip="setTooltip(13)" :shape="shape" :type="displayType" v-on:lock="lock(index)"></lock>
                            </div>

                            <div class="btn-group m-r-5">
                                <flipx @tooltip="setTooltip(24)" v-on:flipX="flipX(index)"></flipx>
                                <flipy @tooltip="setTooltip(25)" v-on:flipY="flipY(index)"></flipy>
                            </div>
                            <ul>
                                <li>Name: <input type="text" @input="updateObject(index, $event)" v-model="shape.custom.name" /></li>
                                <li class="img">
                                    <span>File Upload:</span>
                                    <img :src="shape.src" v-if="shape.src" />
                                    <div class="upload-btn-wrapper">
                                        <button :class="{'btn-warning': shape.custom.uploadButton !== 'Select Image File'}" class="btn btn-success">{{ shape.custom.uploadButton }}</button>
                                        <input type="file" accept="image/*" @change="updateImage(index, $event.target)" />
                                    </div>
                                </li>
                                <li>Scale: {{ shape.scaleX * 100 }}% <input type="range" v-on:change="updateObject(index, $event)" min="0" max="1" step="0.01" v-model="shape.scaleX"> </li>
                                <li v-if="displayType === 'editor'">
                                    Clipping Mask:
                                    <select v-model="shape.custom.clipto" @change="applyMask(index, $event.target.value, true, false)">
                                        <option :data-index="-1" value="-1">No Clipping Mask</option>
                                        <option v-for="(mask, i) in clippingMasks" :value="i">
                                            {{ mask.custom.name }}
                                        </option>
                                    </select>
                                </li>
                            </ul>

                            <button :class="{'confirmed': shape.custom.confirmed}" class="btn confirmBtn btn-block m-b-5 m-t-5" v-if="displayType === 'designer'" @click="confirmEdit(index)">{{ (shape.custom.confirmed) ? 'Confirmed' : 'Confirm' }}</button>
                        </div>
                    </div>
                </div>

                <!-- ## BACKGROUND & MARGINS ## -->
                <div class="panel panel-default m-b-20" v-if="displayType === 'editor'">
                    <a data-toggle="collapse" data-parent="#accordion-test" href="#collapse100" class="collapsed" aria-expanded="false">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <i class="icon-image m-r-5"></i>
                                Background &amp; Margins
                                <i class="icon-lock right"></i>
                            </h4>
                        </div>
                    </a>
                    <div id="collapse100" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
                        <div class="panel-body">
                            <ul>
                                <li class="left sizeSettings" @mouseenter="setTooltip(23)" @mouseleave="setTooltip(23)">Safe Area: <input type="number" @input="setSafe($event.target.value)" v-model="prodSafe" step="0.001" disabled="disabled" /></li>
                                <li class="left sizeSettings m-r-0" @mouseenter="setTooltip(22)" @mouseleave="setTooltip(22)">Trim: <input type="number" @input="setTrim($event.target.value)" v-model="prodBleed" step="0.001" disabled="disabled" /></li>
                                <li class="img">
                                    <span>File Upload:</span>
                                    <img :src="$store.state.template.files[$store.state.activeTemplate].json.backgroundImage.src" v-if="$store.state.template.files[$store.state.activeTemplate].json && $store.state.template.files[$store.state.activeTemplate].json.backgroundImage && $store.state.template.files[$store.state.activeTemplate].json.backgroundImage.src" />
                                    <div class="upload-btn-wrapper">
                                        <button class="btn btn-success">Select Image File</button>
                                        <input type="file" accept="image/*" @change="updateBackground($event.target)" />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- ## SAVE & CONTINUE ## -->
                <transition-group enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut" v-if="displayType === 'designer' && this.proceed.show !== false">
                    <button :key="0" :disabled="(!templateName || $store.state.savedTemplate.id === this.$store.state.template.id)" v-if="$store.state.savedTemplate !== null" @click.prevent="updateExistingTemplate(loadNextTemplate, $event)" type="button" class="btn block btn-md waves-effect waves-light saveButtons btn-success m-t-10" style="font-size: 1.1em; padding: 8px 0;">
                        {{ ($store.state.savedTemplate.id !== this.$store.state.template.id) ? 'Save & Continue' : 'Loading, Please Wait..' }}
                    </button>
                    <button :key="1" v-else :disabled="!templateName" @click.prevent="saveAsNewTemplate(loadNextTemplate, $event)" type="button" class="btn block btn-md waves-effect waves-light saveButtons btn-success m-t-10" style="font-size: 1.1em; padding: 8px 0;">
                        Save & Continue
                    </button>
                </transition-group>
                <transition-group enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut" v-if="displayType === 'designer' && this.proceed.show === false">
                    <div :key="0" class="noEdit m-t-20">
                        Please confirm all fields to continue.
                    </div>
                </transition-group>

                <div class="panel panel-default m-b-20" v-if="displayType === 'editor'">
                    <div class="panel-heading" @click="toggleShortcuts()" style="cursor: pointer;">
                        <h4 class="panel-title">
                            <i class="icon-keyboard m-r-5"></i>
                            Keyboard Shortcuts
                        </h4>
                    </div>
                    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                        <div class="panel-body" v-if="shortcuts">
                            <table class="table m-0">
                                <thead>
                                    <tr>
                                        <th>Shortcut</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Shift</td>
                                        <td><em>With Selected Object:</em> Holding shift while dragging will lock the object so that it can only move up and down.</td>
                                    </tr>
                                    <tr>
                                        <td>Command&nbsp;&nbsp;</td>
                                        <td><em>With Selected Object:</em> Holding command while dragging will lock the object so that it can only move left and right.</td>
                                    </tr>
                                    <tr>
                                        <td>&#8678;<br />Shift + &#8678;<br />Option + &#8678;</td>
                                        <td>
                                            <em>With Selected Object:</em> Move object 1 pixel left.<br />
                                            Holding shift will move 10 pixels at a time.<br />
                                            Holding option will move 25 pixels at a time.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&#8680;<br />Shift + &#8680;<br />Option + &#8680;</td>
                                        <td>
                                            <em>With Selected Object:</em> Move object 1 pixel right.<br />
                                            Holding shift will move 10 pixels at a time.<br />
                                            Holding option will move 10 pixels at a time.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&#8679;<br />Shift + &#8679;<br />Option + &#8679;</td>
                                        <td>
                                            <em>With Selected Object:</em> Move object 1 pixel up.<br />
                                            Holding shift will move 10 pixels at a time.<br />
                                            Holding option will move 10 pixels at a time.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&#8681;<br />Shift + &#8681;<br />Option + &#8681;</td>
                                        <td>
                                            <em>With Selected Object:</em> Move object 1 pixel down.<br />
                                            Holding shift will move 10 pixels at a time.<br />
                                            Holding option will move 10 pixels at a time.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Delete ⌦</td>
                                        <td>
                                            <em>With Selected Object:</em> Deletes object from canvas
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </transition>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
/* global Helpers */

import {fabric} from 'fabric'
import _ from 'lodash'
import WebFont from 'webfontloader'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
import ConfirmDelete from './ConfirmDelete.vue'
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'

// Buttons
import lock from './buttons/lock.vue'
import editable from './buttons/editable.vue'
import visible from './buttons/visible.vue'
import copy from './buttons/copy.vue'
import flipx from './buttons/flipx.vue'
import flipy from './buttons/flipy.vue'
import alignCenter from './buttons/alignCenter.vue'
import alignJustify from './buttons/alignJustify.vue'
import alignLeft from './buttons/alignLeft.vue'
import alignRight from './buttons/alignRight.vue'
import italic from './buttons/italic.vue'
import bold from './buttons/bold.vue'
import underline from './buttons/underline.vue'
import autoScale from './buttons/autoScale.vue'
import smallCaps from './buttons/smallCaps.vue'

// Mixins
import { windowMessaging } from '@/components/mixins/windowMessaging'
import { templateSaving } from '@/components/mixins/templateSaving'
import { keyboardShortcuts } from '@/components/mixins/keyboardShortcuts'
import { textFilters } from '@/components/mixins/textFilters'

// Filters
import filters from '@/components/filters/all'

export default {
    name: 'Canvas',
    components: {lock, editable, visible, copy, flipx, flipy, alignCenter, alignJustify, alignLeft, alignRight, italic, bold, underline, autoScale, smallCaps, ConfirmDelete, FulfillingBouncingCircleSpinner},
    mixins: [windowMessaging, templateSaving, keyboardShortcuts, textFilters],
    props: {
        prodWidth: {
            default: 3.5
        },
        prodHeight: {
            default: 2
        },
        prodSafe: {
            default: 0.0625
        },
        prodBleed: {
            default: 0.0625
        },
        displayType: {
            default: 'designer'
        },
        template: {
            default: null
        }
    },
    data () {
        return {
            msg: 'Template Test',
            exampleContent: 'This is TEXT',
            canvas: null,
            searchSaved: '',
            productWidth: null,
            productHeight: null,
            productPixelWidth: null,
            productPixelHeight: null,
            canvasStartWidth: null,
            canvasStartHeight: null,
            canvasScale: 1,
            clippingMasks: [],
            tooltip: null,
            zoom: 1,
            resizeTimer1: null,
            resizeTimer2: null,
            lastScale: 0,
            canvasData: [],
            prevDirection: 'none',
            currentTrim: null,
            currentSafe: null,
            trimObject: null,
            safeObject: null,
            selected: null,
            newTemplate: false,
            savedTemplates: (this.$store.state.template.userversions !== undefined) ? this.$store.state.template.userversions.data : [],
            templateName: this.$store.state.templateName,
            templateTransition: false,
            json: null,
            proceed: {
                show: false,
                target: null
            },
            shortcuts: false,
            loadingStatus: 'Loading..',
            loadingComplete: false,
            noEditableLayers: false,
            dataAttributes: [],
            watcher: null
        }
    },
    computed: {
        canvasDataReverse () {
            return _.orderBy(this.canvasData, [(o) => { return this.canvasData.indexOf(o) }], ['desc'])
        },
        savedTemplatesToRender () {
            let parent = this

            if (this.searchSaved === null) {
                return this.$store.state.template.userversions.data
            } else {
                return this.$store.state.template.userversions.data.filter(function (version) {
                    return version.name.toLowerCase().includes(parent.searchSaved.toLowerCase())
                })
            }
        }
    },
    methods: {
        /**
         * Update Object fires when a form field for a canvas object has been modified
         * @param  {event} e Canvas objects array key
         * @return {void}
         */
        updateObject (key, e) {
            let item = this.canvasDataReverse[key]
            key = this.canvasData.indexOf(item)

            if (item.fontFamily !== undefined) {
                this.loadFonts([item.fontFamily], null, null, false)
            }

            this.$store.commit('templateChanges', true)

            // Reset The Confirmed State for the File
            this.dirtyCanvas()

            // Reset The Confirmed State for the Field
            this.canvasData[key].custom.confirmed = false
            this.canvasData[key].dirty = true

            if (this.canvasData[key].type === 'textbox') {
                this.updateTextElement(this.canvasData[key], e)
                this.limitChars(this.canvasData[key])

                // Should we auto scale the font size
                if (this.canvasData[key].custom.autoscale === true) {
                    // Force Pixels
                    if (this.canvasData[key].custom.fontUnits !== 'px') {
                        this.canvasData[key].custom.fontUnits = 'px'
                        this.canvasData[key].setFontSize(this.canvasData[key].custom.fontSize + this.canvasData[key].custom.fontUnits)
                    }
                    // Scale
                    this.canvasData[key].scaleFontSize()
                } else {
                    // Set Font Size
                    this.canvasData[key].setFontSize(this.canvasData[key].custom.fontSize + this.canvasData[key].custom.fontUnits)
                }
            }

            // Sync Image Scaling
            if (this.canvasData[key].type === 'image') {
                if (this.canvasData[key].scaleX !== this.canvasData[key].scaleY) {
                    this.canvasData[key].scaleY = this.canvasData[key].scaleX
                }
            }

            this.canvas.item(key).setCoords()
            this.canvas.renderAll()
            this.proceed.show = false

            this.$forceUpdate()
        },
        updateTextElement (textBoxData, event) {
            let skip = ['telephone1', 'telephone2', 'telephone3', 'date1', 'date2', 'date3']
            let start = event.target.selectionStart
            let end = event.target.selectionEnd
            textBoxData.text = this.textFormat(textBoxData.custom.mask, textBoxData.text)
            if (!skip.includes(textBoxData.custom.mask)) {
                setTimeout(() => {
                    event.target.setSelectionRange(start, end)
                }, 5)
            }
        },
        /**
         * Resize the canvas and scale page & artwork appropriately to fit
         * @return {void}
         */
        resizeCanvas ($size) {
            clearTimeout(this.resizeTimer1)
            clearTimeout(this.resizeTimer2)
            this.resizeTimer1 = setTimeout(() => {
                let maxWidth = $('.containerWrapper').width()
                if ($size !== null && $size.target === undefined) {
                    this.zoom = $size
                }
                let width = maxWidth * this.zoom

                let scale = ((this.productWidth + (this.currentTrim * 2)) * 300) / ((this.productHeight + (this.currentTrim * 2)) * 300)
                this.canvas.setWidth(width)
                this.canvas.setHeight(width / scale)

                let idealWidth = Math.floor((this.productWidth + (this.currentTrim * 2)) * 300)
                this.resizeTimer2 = setTimeout(() => {
                    this.canvas.setZoom(this.canvas.width / idealWidth)
                    this.canvas.calcOffset()
                    this.canvas.renderAll()
                }, 50)

                this.canvasScale = this.canvas.width / idealWidth
                if (this.lastScale !== this.canvasScale) {
                    this.lastScale = this.canvasScale
                    this.windowMsgTemplateResize(this.canvas.height, this.canvas.width)
                }
            }, 100)
        },
        /**
         * Set the trim border on the canvas for reference
         * @param {float} trimSize The trim size to be used to generate the trim marks
         */
        setTrim (trimSize) {
            this.currentTrim = trimSize

            if (this.trimObject !== null) {
                this.canvas.remove(this.trimObject)
            }

            if (this.canvasStartWidth === null) {
                this.canvasStartWidth = this.canvas.width
                this.canvasStartHeight = this.canvas.height
            }

            let productPixelWidth = this.productWidth * 300
            let bleedWidth = this.canvasStartWidth
            let bleedHeight = this.canvasStartHeight

            let scale = (bleedWidth / productPixelWidth) * 100

            trimSize = (trimSize / 100) * scale
            let trim = trimSize * 300 // 300 DPI
            let trimWidth = bleedWidth - (trim * 2)
            let trimHeight = bleedHeight - (trim * 2)

            // Trim
            this.addElement({
                type: 'rect',
                width: trimWidth,
                height: trimHeight,
                left: trim,
                top: trim,
                originX: 0,
                originY: 0,
                fill: null,
                stroke: 'blue',
                strokeWidth: 1,
                selectable: false,
                custom: {
                    name: 'Trim Area',
                    trimSize: trimSize,
                    editable: false
                }
            })
        },
        /**
         * Set the safe border on the canvas for reference
         * @param {float} safeSize The safe size to be used to generate the trim marks
         */
        setSafe (safeSize) {
            this.currentSafe = safeSize

            if (this.safeObject !== null) {
                this.canvas.remove(this.safeObject)
            }

            let productPixelWidth = this.productWidth * 300
            let bleedWidth = this.canvasStartWidth
            let bleedHeight = this.canvasStartHeight

            let scale = (bleedWidth / productPixelWidth) * 100

            // let trimSize = ((this.currentTrim / 100) * scale)
            // let trim = trimSize * 300 // 300 DPI

            safeSize = (safeSize / 100) * scale
            let safe = (safeSize * 300) * 2 // 300 DPI
            let safeWidth = bleedWidth - (safe * 2)
            let safeHeight = bleedHeight - (safe * 2)

            // Safe
            this.addElement({
                type: 'rect',
                width: safeWidth,
                height: safeHeight,
                left: safe,
                top: safe,
                originX: 0,
                originY: 0,
                fill: null,
                stroke: 'green',
                strokeWidth: 1,
                selectable: false,
                custom: {
                    name: 'Safe Area',
                    safeSize: safeSize,
                    editable: false
                }
            })
        },
        /**
         * Add a new element to the canvas
         * @param {object} data Configuration options to be merged with the config defined below as well as the object type that will be added to the canvas
         */
        addElement (data) {
            let element = null
            let config = {
                // Coordinates
                top: 0 - this.canvas.height,
                left: this.canvas.width / 2,
                width: 100,
                height: 100,
                originX: 'center',
                originY: 'center',
                selectable: true,

                // Sizes
                strokeWidth: 0,

                // Colors
                fill: '#7F7E80',
                borderColor: '#7F7E80',
                stroke: '#7F7E80',

                // Fonts
                fontSize: '36',

                // Corner Styling
                padding: 8,
                cornerSize: 14,
                cornerStyle: 'circle',
                cornerColor: '#76C15D',
                cornerStrokeColor: '#ffffff',
                rotatingPointOffset: 20,
                transparentCorners: false,
                uniScaleTransform: true,
                selectionBackgroundColor: 'rgba(210,210,210,0.2)',

                // Custom
                custom: {
                    name: '',
                    fontSize: 8,
                    fontUnits: 'pt',
                    charLimit: 0,
                    mask: 'standard',
                    editable: true,
                    locked: false,
                    autoscale: false,
                    smallcaps: false,
                    confirmed: false,
                    data_attribute: ''
                }
            }

            config = _.extend({}, config, data)

            if (data.type !== 'image') {
                if (data.type === 'text') {
                    element = new fabric.Textbox('Default Text', {
                        fontFamily: (this.$store.state.activeFonts.length > 0) ? this.$store.state.activeFonts[0] : this.$store.state.fonts[2].name,
                        fontSize: config.fontSize,
                        left: config.left,
                        top: config.top,
                        width: 250,
                        caching: false,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    })
                } else if (data.type === 'rect') {
                    element = new fabric.Rect({
                        left: config.left,
                        top: config.top,
                        fill: config.fill,
                        stroke: config.stroke,
                        strokeWidth: config.strokeWidth,
                        width: config.width,
                        height: config.height,
                        originX: config.originX,
                        originY: config.originX,
                        selectable: config.selectable,
                        perPixelTargetFind: true,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    })
                } else if (data.type === 'clipping-area') {
                    element = new fabric.Rect({
                        left: config.left,
                        top: config.top,
                        fill: 'transparent',
                        stroke: config.stroke,
                        strokeWidth: 1,
                        strokeDashArray: [4, 2],
                        width: config.width,
                        height: config.height,
                        originX: config.originX,
                        originY: config.originX,
                        selectable: config.selectable,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    })
                    this.clippingMasks.push(element)
                } else if (data.type === 'round-clipping-area') {
                    element = new fabric.Ellipse({
                        left: config.left,
                        top: config.top,
                        fill: 'transparent',
                        stroke: config.stroke,
                        strokeWidth: 1,
                        strokeDashArray: [4, 2],
                        originX: config.originX,
                        originY: config.originX,
                        selectable: config.selectable,
                        rx: config.width / 2,
                        ry: config.height / 2,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    })
                    this.clippingMasks.push(element)
                } else if (data.type === 'ellipse') {
                    element = new fabric.Ellipse({
                        left: config.left,
                        top: config.top,
                        fill: config.fill,
                        stroke: config.stroke,
                        strokeWidth: config.strokeWidth,
                        selectable: config.selectable,
                        originX: config.originX,
                        originY: config.originX,
                        rx: config.width / 2,
                        ry: config.height / 2,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    })
                } else if (data.type === 'triangle') {
                    element = new fabric.Triangle({
                        left: config.left,
                        top: config.top,
                        fill: config.fill,
                        stroke: config.stroke,
                        strokeWidth: config.strokeWidth,
                        selectable: config.selectable,
                        originX: config.originX,
                        originY: config.originX,
                        width: config.width,
                        height: config.height,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    })
                }

                // If this isnt our safe or trim, let's animate the adding process
                if (element.custom.name !== 'Safe Area' && element.custom.name !== 'Trim Area') {
                    element.left = (this.canvas.width / 2) - (element.width / 2)
                    this.canvas.add(element)
                    element.animate('top', ((this.canvas.height / 2) - (element.height / 2)), {
                        duration: 500,
                        onChange: this.canvas.renderAll.bind(this.canvas),
                        onComplete: () => {
                            this.canvas.deactivateAll().renderAll()
                            this.canvas.setActiveObject(element)
                            if (data.type !== 'clipping-area') {
                                element.setFontSize('10pt')
                            }
                        },
                        easing: fabric.util.ease['easeOutBack']
                    })
                } else {
                    this.canvas.add(element)
                }
            } else {
                config.custom.name = 'New Image'
                config.custom.clipto = '-1'
                config.custom.uploadButton = 'Select Image File'

                fabric.Image.fromURL('/static/1x1.png', (img) => {
                    img.set({
                        left: -10,
                        top: -10,
                        originX: config.originX,
                        originY: config.originX,
                        perPixelTargetFind: false,
                        selectable: false,
                        lockUniScaling: true,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    })
                    this.canvas.add(img)
                    setTimeout(() => {
                        this.canvas.deactivateAll().renderAll()
                        this.canvas.setActiveObject(img)
                    }, 250)
                }, { crossOrigin: 'Anonymous' })
            }

            // Surface out trim and safe lines to keep them visible
            if (this.trimObject !== null) {
                this.trimObject.bringToFront()
            }
            if (this.safeObject !== null) {
                this.safeObject.bringToFront()
            }

            this.canvasData = this.canvas.getObjects()
        },
        /**
         * Remove an object from the canvas
         * @return {void}
         */
        removeElement () {
            if (this.canvas.getActiveGroup()) {
                this.canvas.getActiveGroup().forEachObject((o) => {
                    if (this.checkMaskUse(o)) {
                        this.canvas.remove(o)
                    }
                })
                this.canvas.discardActiveGroup().renderAll()
            } else {
                if (this.checkMaskUse(this.canvas.getActiveObject())) {
                    let item = this.canvas.getActiveObject()
                    let idx = this.canvasDataReverse.indexOf(item)
                    this.canvas.remove(item)
                    $('a[href=#collapse' + idx + ']').trigger('click')
                }
            }
        },
        /**
         * Check if the object is a clipping-mask and check if it is currently being used to clip an image on the canvas
         * @param  {object} obj A object from the canvas
         * @return {boolean}
         */
        checkMaskUse (obj) {
            if (obj.custom.type === 'clipping-mask') {
                let target = null
                for (let i in this.clippingMasks) {
                    if (this.clippingMasks[i] === obj) {
                        target = i
                    }
                }
                if (target !== null) {
                    for (var i in this.canvasData) {
                        // If mask is in use stop the execution and alert user
                        if (this.canvasData[i].custom !== undefined && this.canvasData[i].custom.clipto === target) {
                            swal({
                                text: 'This mask is currently in use, you must detach image from this mask before removing.'
                            })
                            return false
                        }
                    }
                    // Mask isn't in use so let's remove it from the masks array
                    this.clippingMasks.splice(target, 1)
                }
            }

            return true
        },
        /**
         * Set current active object
         * @param {integer} index Index id of object to target int he canvas array
         */
        setActiveObject (index) {
            let item = this.canvasDataReverse[index]
            let target = this.canvasData.indexOf(item)
            this.canvas.setActiveObject(this.canvas.item(target))
        },
        /**
         * Export the canvas data out to the vuex store
         * @return {void}
         */
        exportData () {
            // Unclip All Masks
            for (let i in this.canvasData) {
                if (this.canvasData[i].clipTo !== null) {
                    this.canvasData[i].clipTo = null
                }
                // Set all starting fields that can be edited to unconfirmed
                if (this.$store.state.mode === 'editor' && this.canvasData[i].custom.editable === true) {
                    this.canvasData[i].custom.confirmed = false
                }
            }

            Object.keys(this.$store.state.template.files).forEach((key) => {
                if (key === this.$store.state.activeTemplate) {
                    let template = this.$store.state.template
                    template.files[key].json = this.canvas.toDatalessJSON(['custom'])
                    this.$store.commit('template', template)
                }
            })

            // Reapply All Masks
            this.applyAllMasks()
        },
        /**
         * Confirm changes to an object that has been edited
         * @param  {integer} e index id of object to be confirmed
         * @return {void}
         */
        confirmEdit (e) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)
            this.canvasData[e].custom.confirmed = true
            this.canvas.discardActiveObject().renderAll()
            this.loopConfirm()
        },
        /**
         * Loop items from canvas object and check that all have been confirmed. This function also sets the next available template for the continue button.
         * @return {boolean}
         */
        loopConfirm () {
            for (var i in this.canvasDataReverse) {
                if (this.canvasDataReverse[i].custom.confirmed === false && this.canvasDataReverse[i].custom.editable === true) {
                    this.canvas.setActiveObject(this.canvasDataReverse[i])
                    return true
                }
            }

            let next = null

            // Loop Templates & Check Confirmed
            Object.keys(this.$store.state.template.files).forEach((key) => {
                if (key !== this.$store.state.activeTemplate && this.$store.state.template.files[key].confirmed === false && next === null) {
                    next = key
                    this.proceed.show = true
                    this.proceed.target = key
                }
            })

            if (next === null) {
                this.proceed.show = 'options'
            }

            $('.layers div a[aria-expanded="true"]').trigger('click')
        },
        /**
         * Load next template or the options page
         * @return {void}
         */
        loadNextTemplate (data = null) {
            if (this.checkConfirmed()) {
                Object.keys(this.$store.state.template.files).forEach((key) => {
                    if (key === this.$store.state.activeTemplate) {
                        let template = this.$store.state.template
                        template.files[key].confirmed = true
                        this.$store.commit('template', template)

                        if (this.proceed.show === 'options') {
                            this.$router.push('/options')
                        } else {
                            this.$store.commit('activeTemplate', this.proceed.target)
                        }
                    }
                })
            }
        },
        removeSavedTemplate (index) {
            let template = this.$store.state.template
            template.userversions.data.splice(index, 1)
            this.$store.commit('template', template)
        },
        /**
         * Check that all items in the canvas object have been confirmed
         * @return {boolean}
         */
        checkConfirmed () {
            for (var i in this.canvasData) {
                if (this.canvasData[i].custom.editable === true && this.canvasData[i].custom.confirmed === false) {
                    return false
                }
            }

            return true
        },

        /* Layer Movement */
        /* -------------- */
        moveLayer (id, direction) {
            let item = this.canvas.getActiveObject()
            let startingIndex = this.canvasDataReverse.indexOf(item)
            let endingIndex = null

            if (direction === 'front') {
                item.bringToFront()
            } else if (direction === 'forward') {
                item.bringForward()
            } else if (direction === 'backward') {
                item.sendBackwards()
            } else if (direction === 'back') {
                item.sendToBack()
            }

            // Bring Trim & Bleed to Front
            if (this.trimObject !== null) {
                this.trimObject.bringToFront()
            }
            if (this.safeObject !== null) {
                this.safeObject.bringToFront()
            }

            endingIndex = this.canvasDataReverse.indexOf(item)
            if (startingIndex !== endingIndex) {
                this.$store.commit('templateChanges', true)
                $('a[href=#collapse' + endingIndex + ']').trigger('click')
            }
        },

        /* Group Functions */
        /* --------------- */
        /**
         * Refresh all items in canvas object group
         * @param  {object} group group of canvas items to be refreshed
         * @return {void}
         */
        groupItemsRefresh (group) {
            group.forEachObject(function (item) {
                group.removeWithUpdate(item).addWithUpdate(item)
            })
            group.setCoords()
            this.canvas.renderAll()
        },
        /**
         * Align selected canvas items with each other
         * @param  {string} direction Alignment direction: left, right, center, top, bottom
         * @return {void}
         */
        groupAlign (direction) {
            var group = this.canvas.getActiveGroup()
            let item = this.canvas.getActiveObject()

            if (direction === this.prevDirection || (!group && !item)) {
                return
            }

            if (group) {
                var groupWidth = group.getBoundingRect(true).width
                var groupHeight = group.getBoundingRect(true).height
                var scaleFactor = group.getScaleX()

                group.forEachObject((item) => {
                    var itemWidth = item.getBoundingRect().width * scaleFactor
                    var itemHeight = item.getBoundingRect().height * scaleFactor

                    if (direction === 'left') {
                        item.set({
                            left: -(groupWidth / 2),
                            originX: 'left'
                        })
                    } else if (direction === 'top') {
                        item.set({
                            top: -groupHeight / 2 + itemHeight / 2
                        })
                    } else if (direction === 'right') {
                        item.set({
                            left: (groupWidth / 2 - itemWidth / 2),
                            originX: 'center'
                        })
                    } else if (direction === 'bottom') {
                        item.set({
                            top: groupHeight / 2 - itemHeight / 2
                        })
                    } else if (direction === 'center') {
                        item.set({
                            left: (0 - itemWidth / 2),
                            originX: 'left'
                        })
                    } else if (direction === 'vertical-center') {
                        item.set({
                            top: (0 - itemHeight / 2),
                            originY: 'top'
                        })
                    }

                    this.prevDirection = direction
                })
                this.groupItemsRefresh(group)
            } else if (item) {
                let canvasWidth = this.canvasStartWidth
                let canvasHeight = this.canvasStartHeight

                if (direction === 'left') {
                    item.set({
                        left: 0,
                        originX: 'left'
                    })
                } else if (direction === 'top') {
                    item.set({
                        top: 0,
                        originY: 'top'
                    })
                } else if (direction === 'right') {
                    item.set({
                        left: canvasWidth,
                        originX: 'right'
                    })
                } else if (direction === 'bottom') {
                    item.set({
                        top: canvasHeight,
                        originY: 'bottom'
                    })
                } else if (direction === 'center') {
                    item.set({
                        left: (canvasWidth / 2) - (item.width * item.getScaleX() / 2),
                        originX: 'left'
                    })
                } else if (direction === 'vertical-center') {
                    item.set({
                        top: (canvasHeight / 2) - (item.height * item.getScaleX() / 2),
                        originY: 'top'
                    })
                }
                item.setCoords()
                this.canvas.renderAll()
            }
        },

        /**
         * Align selected canvas items with each other
         * @param  {string} direction Alignment direction: left, right, center, top, bottom
         * @return {void}
         */
        evenlySpace (direction) {
            var group = this.canvas.getActiveGroup()

            if (direction === this.prevDirection || !group) {
                return
            }

            var groupWidth = group.getBoundingRect(true).width
            var groupHeight = group.getBoundingRect(true).height
            var scaleFactor = group.getScaleX()
            var total = group.getObjects().length
            var current = 0
            var orderHorizontal = []
            var orderVertical = []

            group.forEachObject(function (item) {
                // let bound = item.getBoundingRect();
                orderHorizontal.push(item.left)
                orderVertical.push(item.top)
                if (direction === 'horizontal' && (current === 0 || current === (total - 1))) {
                    groupWidth -= (item.width / 2)
                } else if (direction === 'vertical' && (current === 0 || current === (total - 1))) {
                    groupHeight -= (item.height / 2)
                }
                current++
            })

            for (let i in orderHorizontal) {
                orderHorizontal[i] += (groupWidth / 2)
            }
            for (let i in orderVertical) {
                orderVertical[i] += (groupHeight / 2)
            }
            orderHorizontal = _.sortBy(orderHorizontal, function (num) { return num })
            orderVertical = _.sortBy(orderVertical, function (num) { return num })

            current = 0
            var spacing = (direction === 'vertical') ? (groupHeight * scaleFactor) / (total - 1) : (groupWidth * scaleFactor) / (total - 1)

            group.forEachObject((item) => {
                let horizontalIndex = orderHorizontal.indexOf(item.left + (groupWidth / 2))
                let verticalIndex = orderVertical.indexOf(item.top + (groupHeight / 2))
                if (direction === 'horizontal' && horizontalIndex !== 0 && horizontalIndex !== (total - 1)) {
                    item.set({
                        left: -(groupWidth / 2) + (spacing * horizontalIndex),
                        originX: 'center'
                    })
                    orderHorizontal[horizontalIndex] = 0.01
                } else if (direction === 'vertical' && verticalIndex !== 0 && verticalIndex !== (total - 1)) {
                    item.set({
                        top: -(groupHeight / 2) + (spacing * verticalIndex),
                        originY: 'center'
                    })
                    orderVertical[verticalIndex] = 0.01
                }

                current++
                this.prevDirection = direction
            })
            this.groupItemsRefresh(group)
        },

        /* Image Functions */
        /* --------------- */
        /**
         * Generate preview image from canvas
         * @return {void}
         */
        generateImage (target = null) {
            // let parnt = this
            let currentZoom = this.zoom
            let pos = 0
            target = (target !== null) ? target : this.$store.state.activeTemplate

            Object.keys(this.$store.state.template.files).forEach((key) => {
                if (key === target) {
                    // this.resizeCanvas(1 + (parseFloat(this.prodBleed) * 2))
                    // Hide Trim & Bleed Layers and Remove Clipping Strokes
                    let hidden = []
                    let differentStrokes = []
                    for (let i in this.canvasData) {
                        if (this.canvasData[i].custom !== undefined && (this.canvasData[i].custom.name === 'Trim Area' || this.canvasData[i].custom.name === 'Safe Area')) {
                            this.canvasData[i].visible = false
                            hidden.push(i)
                        }

                        if (this.canvasData[i].custom !== undefined && this.canvasData[i].custom.type === 'clipping-mask') {
                            differentStrokes[i] = this.canvasData[i].strokeWidth
                            this.canvasData[i].strokeWidth = 0
                        }
                    }
                    this.canvas.setWidth(Math.ceil((this.productWidth + (this.currentTrim * 2)) * 300))
                    this.canvas.setHeight(Math.ceil((this.productHeight + (this.currentTrim * 2)) * 300))
                    this.canvas.setZoom(1)
                    this.canvas.calcOffset()
                    this.canvasScale = 1

                    // Generate Image
                    let image = this.canvas.toDataURL({
                        format: 'jpeg',
                        quality: 1,
                        multiplier: 1
                    })

                    this.resizeCanvas(currentZoom)

                    // Restore Trim & Bleed
                    for (let x in hidden) {
                        this.canvasData[hidden[x]].visible = true
                    }
                    // Restore Mask Strokes
                    for (let x in differentStrokes) {
                        this.canvasData[x].strokeWidth = differentStrokes[x]
                    }
                    this.canvas.renderAll()
                    let template = this.$store.state.template
                    template.files[key].preview = image
                    if (this.$store.state.mode === 'editor') {
                        template.previews[pos] = image
                    }
                    this.$store.commit('template', template)
                }
                pos += 1
            })
        },
        /**
         * Apply selected mask to an image on the canvasData
         * @param  {object}  image      selected image to have mask applied to
         * @param  {object}  mask       mask to be applied to selected image
         * @param  {boolean} reposition should the image be reposition when the mask is applied
         * @param  {boolean} primaryArray does the image id point to the primary canvasData array or the secondary canvasDataReverse
         * @return {void}
         */
        applyMask (image, mask, reposition, primaryArray) {
            let img = null
            if (primaryArray === true) {
                img = this.canvasData[image]
            } else {
                img = this.canvasDataReverse[image]
                img = this.canvasData.indexOf(img)
                img = this.canvasData[img]
            }

            if (mask === 'No Clipping Mask' || mask === '-1' || mask === -1) {
                img.clipTo = null
            } else {
                let posLeft = this.clippingMasks[mask].getLeft() + (this.clippingMasks[mask].getWidth() / 2)
                let posTop = this.clippingMasks[mask].getTop() + (this.clippingMasks[mask].getHeight() / 2)

                if (reposition) {
                    img.top = posTop
                    img.left = posLeft
                }
                img.custom.clipto = mask

                img.clipTo = (ctx) => {
                    ctx.save()

                    let pixelRatio = window.devicePixelRatio
                    let scale = this.canvasScale * pixelRatio
                    // * 2
                    ctx.setTransform(scale, 0, 0, scale, 0, 0)
                    // ctx.setTransform(scale, 0, 0, scale, this.clippingMasks[mask].getLeft(), this.clippingMasks[mask].getTop())
                    // ctx.setTransform(scale, 0, 0, scale, posLeft, posTop)

                    let w = this.clippingMasks[mask].getWidth()
                    let h = this.clippingMasks[mask].getHeight()

                    ctx.rect(0, 0, w, h)
                    this.clippingMasks[mask].render(ctx)
                    ctx.restore()
                }
            }
            this.canvas.renderAll()
        },
        /**
         * Reapply all masks on the canvas - mainly used when an existing template is loaded for the first time
         * @return {void}
         */
        applyAllMasks () {
            // Reapply All Masks
            for (let i in this.canvasData) {
                if (this.canvasData[i].custom !== undefined && this.canvasData[i].custom.clipto !== undefined && this.canvasData[i].custom.clipto !== null) {
                    this.applyMask(i, this.canvasData[i].custom.clipto, false, true)
                }
            }
        },
        /**
         * Replace existing image with new upload
         * @param  {integer} index  image index in canvas object array
         * @param  {string}  target file uploader that has the newly selected file
         * @return {void}
         */
        updateImage (index, target) {
            var data = new FormData()
            // let origIndex = index
            let item = this.canvasDataReverse[index]
            index = this.canvasData.indexOf(item)

            data.append('file', target.files[0])
            var config = {
                onUploadProgress: (progressEvent) => {
                    let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    this.canvas.item(index).custom.uploadButton = 'Uploading: ' + percentCompleted + '%'
                }
            }

            this.axios.post('/upload/image', data, config)
            .then((response) => {
                let positionLeft = (this.canvas.item(index).getLeft() < 0) ? 0 : this.canvas.item(index).getLeft()
                let positionTop = (this.canvas.item(index).getTop() < 0) ? 0 : this.canvas.item(index).getTop()
                let positionAngle = this.canvas.item(index).getAngle()
                let scaleX = this.canvas.item(index).getScaleX()
                let scaleY = this.canvas.item(index).getScaleY()

                fabric.Image.fromURL(response.data, (img) => {
                    img.set({
                        left: positionLeft,
                        top: positionTop,
                        angle: positionAngle,
                        scaleX: scaleX,
                        scaleY: scaleY,
                        centeredScaling: true,
                        originX: 'center',
                        originY: 'center',
                        perPixelTargetFind: false,
                        lockUniScaling: true,
                        src: response.data,
                        // selectable: true,
                        custom: this.canvas.item(index).custom
                    })
                    this.canvas.add(img)

                    // Check if we need to apply a clipping mask
                    let clipto = null
                    if (this.canvas.item(index).custom.clipto !== null) {
                        clipto = this.canvas.item(index).custom.clipto // *******************************************##########
                    }

                    this.canvas.item(index).remove()
                    img.moveTo(index)

                    // Apply Clipping Mask
                    if (clipto !== null) {
                        this.applyMask(index, clipto, true, true)
                    }

                    this.canvas.item(index).custom.uploadButton = 'Select Image File'
                }, { crossOrigin: 'Anonymous' })

                this.$store.commit('templateChanges', true)
                this.canvas.renderAll()
            })
            .catch(function (err) {
                Helpers.errorPop('Error', err.response.data.message)
            })
        },

        /**
         * Replace existing image with new upload
         * @param  {string}  target file uploader that has the newly selected file
         * @return {void}
         */
        updateBackground (target) {
            var data = new FormData()
            let canvasWidth = this.canvasStartWidth
            let canvasHeight = this.canvasStartHeight

            data.append('file', target.files[0])
            var config = {
                onUploadProgress: function (progressEvent) {
                    // var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total )
                    // console.log(Math.round((progressEvent.loaded * 100) / progressEvent.total))
                }
            }

            // left: (canvasWidth / 2) - (item.width * item.getScaleX() / 2),
            this.axios.post('/upload/image', data, config)
            .then((response) => {
                fabric.Image.fromURL(response.data, (img) => {
                    img.set({
                        originX: 'center',
                        originY: 'center',
                        left: (canvasWidth / 2),
                        top: (canvasHeight / 2)
                    })
                    this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas))

                    if (this.$store.state.template.files[this.$store.state.activeTemplate].json !== null && this.$store.state.template.files[this.$store.state.activeTemplate].json.backgroundImage !== undefined) {
                        this.$store.state.template.files[this.$store.state.activeTemplate].json.backgroundImage.src = response.data
                    }
                    this.dirtyCanvas()
                    this.$store.commit('templateChanges', true)
                }, { crossOrigin: 'Anonymous' })
            })
            .catch(function (err) {
                Helpers.errorPop('Error', err.response.data.message)
            })
        },

        /* Layer Functions */
        /* --------------- */
        /**
         * Scale canvas item to value
         * @param  {integer} e     id of canvas item object
         * @param  {float}   value number to scale to
         * @return {void}
         */
        scale (e, value) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)
            this.canvasData[e].scaleX = value
            this.canvasData[e].scaleY = value
            this.canvas.renderAll()
            this.$forceUpdate()
        },
        /**
         * Flip canvas item vertically
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        flipX (e) {
            if (e !== null) {
                let item = this.canvasDataReverse[e]
                e = this.canvasData.indexOf(item)
                this.canvasData[e].flipX = !this.canvasData[e].flipX
                this.canvasData[e].dirty = true
            } else if (this.canvas.getActiveGroup() !== null) {
                e = this.canvas.getActiveGroup()
                e.toggle('flipX')
            } else if (this.canvas.getActiveObject() !== null) {
                e = this.canvas.getActiveObject()
                e.toggle('flipX')
            }
            this.canvas.renderAll()
            this.$forceUpdate()
        },
        /**
         * Flip canvas item horizontally
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        flipY (e) {
            if (e !== null) {
                let item = this.canvasDataReverse[e]
                e = this.canvasData.indexOf(item)
                this.canvasData[e].flipY = !this.canvasData[e].flipY
                this.canvasData[e].dirty = true
            } else if (this.canvas.getActiveGroup() !== null) {
                e = this.canvas.getActiveGroup()
                e.toggle('flipY')
            } else if (this.canvas.getActiveObject() !== null) {
                e = this.canvas.getActiveObject()
                e.toggle('flipY')
            }
            this.canvas.renderAll()
            this.$forceUpdate()
        },
        /**
         * Toggle locked canvas item state so that it can't be edited or selected
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        lock (e) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)
            if (this.canvasData[e].lockMovementX !== false) {
                this.canvasData[e].custom.locked = false
                this.canvasData[e].lockMovementX = false
                this.canvasData[e].lockMovementY = false
                this.canvasData[e].lockRotation = false
                this.canvasData[e].lockScalingX = false
                this.canvasData[e].lockScalingY = false
                this.canvasData[e].setControlsVisibility({ bl: true, br: true, mb: true, ml: true, mr: true, mt: true, tl: true, tr: true, mtr: true })
                if (this.canvasData[e].custom.type === 'clipping-mask' || this.canvasData[e].type === 'image') {
                    this.canvasData[e].selectable = true
                    this.canvasData[e].evented = true
                }
            } else {
                this.canvasData[e].custom.locked = true
                this.canvasData[e].lockMovementX = true
                this.canvasData[e].lockMovementY = true
                this.canvasData[e].lockRotation = true
                this.canvasData[e].lockScalingX = true
                this.canvasData[e].lockScalingY = true
                this.canvasData[e].setControlsVisibility({ bl: false, br: false, mb: false, ml: false, mr: false, mt: false, tl: false, tr: false, mtr: false })
                if (this.canvasData[e].custom.type === 'clipping-mask' || this.canvasData[e].type === 'image') {
                    this.canvasData[e].selectable = false
                    this.canvasData[e].evented = false
                }
            }

            this.canvasData[e].dirty = true
            this.canvas.renderAll()
            this.$forceUpdate()
        },
        /**
         * Toggle editable canvas item state, non editable items won't show in designer mode
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        editable (e) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)

            if (this.canvasData[e].custom === undefined) {
                this.canvasData[e].custom = {
                    editable: true
                }
            }

            if (this.canvasData[e].custom.editable === undefined || this.canvasData[e].custom.editable !== false) {
                this.canvasData[e].custom.editable = false
            } else {
                this.canvasData[e].custom.editable = true
            }
            this.canvasData[e].dirty = true
            this.canvas.renderAll()
            this.$forceUpdate()
        },
        autoScale (e) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)

            if (this.canvasData[e].custom === undefined) {
                this.canvasData[e].custom = {
                    autoscale: false
                }
            }

            if (this.canvasData[e].custom.autoscale === undefined || this.canvasData[e].custom.autoscale !== false) {
                this.canvasData[e].custom.autoscale = false
                this.canvasData[e].custom.maxWidth = null
                this.canvasData[e].custom.maxHeight = null
                this.canvasData[e].custom.topOffset = null
            } else {
                this.canvasData[e].custom.fontUnits = 'px'
                this.canvasData[e].setFontSize(this.canvasData[e].custom.fontSize + this.canvasData[e].custom.fontUnits)
                this.canvasData[e].custom.autoscale = true
                this.canvasData[e].custom.maxWidth = this.canvasData[e].width
                this.canvasData[e].custom.maxHeight = this.canvasData[e].height
                this.canvasData[e].custom.topOffset = this.canvasData[e].top
            }
            this.canvasData[e].dirty = true
            this.canvas.renderAll()
            this.$forceUpdate()
        },
        smallCaps (e) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)

            if (this.canvasData[e].custom === undefined) {
                this.canvasData[e].custom = {
                    smallcaps: false
                }
            }

            if (this.canvasData[e].custom.smallcaps === false) {
                this.canvasData[e].fontStyle = 'small-caps'
                this.canvasData[e].custom.smallcaps = true
            } else {
                this.canvasData[e].fontStyle = 'normal'
                this.canvasData[e].custom.smallcaps = false
            }
            this.canvasData[e].dirty = true
            this.canvas.renderAll()
            this.$forceUpdate()
        },
        /**
         * Toggle visibility of canvas item
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        visible (e) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)

            if (this.canvasData[e].visible !== false) {
                // this.canvasData[e].hasControls = false
                this.canvasData[e].visible = false
            } else {
                // this.canvasData[e].hasControls = true
                this.canvasData[e].visible = true
            }
            this.canvasData[e].dirty = true
            this.canvas.renderAll()
            this.$forceUpdate()
        },
        /**
         * Clones a canvas item and creates a duplicate
         * @return {void}
         */
        clone () {
            var object = this.canvas.getActiveObject().clone()
            object.top = object.top + 5
            object.left = object.left + 5

            // Corner Styling
            object.padding = 8
            object.cornerSize = 14
            object.cornerStyle = 'circle'
            object.cornerColor = '#76C15D'
            object.cornerStrokeColor = '#ffffff'
            object.rotatingPointOffset = 20
            object.transparentCorners = false
            object.uniScaleTransform = true
            object.selectionBackgroundColor = 'rgba(210,210,210,0.2)'

            object.custom = {
                name: '',
                fontsize: 8,
                fontUnits: 'pt',
                charLimit: 0,
                mask: 'standard',
                editable: true,
                locked: false,
                confirmed: false
            }

            if (this.canvas.getActiveObject().type === 'textbox') {
                object.custom.fontSize = this.canvas.getActiveObject().custom.fontSize
                object.custom.fontUnits = this.canvas.getActiveObject().custom.fontUnits
                object.custom.charLimit = this.canvas.getActiveObject().custom.charLimit
            }

            this.canvas.add(object)
            this.canvas.setActiveObject(object)
        },

        /* Font Modifiers */
        /* -------------- */
        limitChars (e) {
            if (e.custom.charLimit > 0) {
                e.text = e.text.substring(0, e.custom.charLimit)
            }
        },
        /**
         * Toggle canvas objects font style to italic
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        fontItalic (e) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)

            if (this.canvasData[e].fontStyle !== 'italic') {
                this.canvasData[e].fontStyle = 'italic'
            } else {
                this.canvasData[e].fontStyle = 'normal'
            }
            this.canvasData[e].dirty = true
            this.canvas.renderAll()
        },
        /**
         * Toggle canvas objects font style to bold
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        fontBold (e) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)

            if (this.canvasData[e].fontWeight !== 'bold') {
                this.canvasData[e].fontWeight = 'bold'
            } else {
                this.canvasData[e].fontWeight = 'normal'
            }
            this.canvasData[e].dirty = true
            this.canvas.renderAll()
        },
        /**
         * Toggle canvas objects font style to underlined
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        fontUnderline (e) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)

            if (this.canvasData[e].textDecoration !== 'underline') {
                this.canvasData[e].textDecoration = 'underline'
            } else {
                this.canvasData[e].textDecoration = null
            }
            this.canvasData[e].dirty = true
            this.canvas.renderAll()
        },
        /**
         * Toggle canvas objects font style to overlined
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        fontOverline (e) {
            let item = this.canvasDataReverse[e]
            e = this.canvasData.indexOf(item)

            if (this.canvasData[e].textDecoration !== 'overline') {
                this.canvasData[e].textDecoration = 'overline'
            } else {
                this.canvasData[e].textDecoration = null
            }
            this.canvasData[e].dirty = true
            this.canvas.renderAll()
        },
        /**
         * Sets alignment of canvas items text
         * @param  {integer} index    id of canvas item object
         * @param  {string}  position left, center, right
         * @return {void}
         */
        textAlign (index, position) {
            let item = this.canvasDataReverse[index]
            index = this.canvasData.indexOf(item)

            this.canvas.item(index).textAlign = position
            this.canvas.renderAll()
        },
        dirtyCanvas () {
            let template = this.$store.state.template
            let file = this.$store.state.activeTemplate
            template.files[file].confirmed = false
            this.$store.commit('template', template)
            this.$store.commit('templateChanges', true)
        },
        /**
         * Initialize the canvas on load
         * @return {void}
         */
        canvasInit () {
            this.canvas.clear()
            this.canvas.backgroundColor = 'white'

            this.setTrim(this.currentTrim)
            this.setSafe(this.currentSafe)
        },
        /**
         * Load the canvas and all objects associated with it from the template
         * @param  {object} template template to be loaded into the canvas
         * @return {void}
         */
        canvasLoad (template) {
            let editableLayers = false

            Object.keys(this.$store.state.template.files).forEach((key) => {
                if (key === template) {
                    this.json = this.$store.state.template.files[key].json
                }
            })

            if (this.json === null) {
                this.canvas.clear()
                this.canvas.backgroundColor = 'white'

                this.setTrim(this.currentTrim)
                this.setSafe(this.currentSafe)
            } else {
                this.canvas.loadFromJSON(this.json, () => {
                    this.canvas.renderAll.bind(this.canvas)

                    if (this.checkConfirmed()) {
                        this.proceed.show = true
                    } else {
                        this.proceed.show = false
                    }

                    if (this.displayType === 'designer') {
                        setTimeout(() => {
                            this.loopConfirm()

                            if (editableLayers === false) {
                                this.noEditableLayers = true
                                $('.saveButtons.continue').html('Continue >').removeAttr('disabled')
                            } else {
                                this.noEditableLayers = false
                            }
                        }, 500)
                    }

                    this.applyAllMasks()

                    // this.setTrim(this.currentTrim)
                    // this.setSafe(this.currentSafe)
                }, (o, object) => {
                    // Load & Stage Each Object //

                    // Build Clipping Masks Array
                    if (object.custom !== undefined) {
                        if (object.custom.type === 'clipping-mask') {
                            let existing = []
                            for (let i in this.clippingMasks) {
                                existing.push(this.clippingMasks[i].custom.name)
                            }
                            if (!existing.includes(object.custom.name)) {
                                this.clippingMasks.push(object)
                            }

                            if (this.$store.state.mode === 'designer') {
                                object.custom.strokeWidth = object.strokeWidth
                                object.strokeWidth = 0
                            } else if (this.$store.state.mode === 'editor' && object.custom.strokeWidth !== undefined && object.custom.strokeWidth !== null) {
                                object.strokeWidth = object.custom.strokeWidth
                            }
                        }

                        if (this.$store.state.mode === 'editor') {
                            object.padding = 8
                            object.cornerSize = 14
                            object.cornerStyle = 'circle'
                            object.cornerColor = '#76C15D'
                            object.cornerStrokeColor = '#ffffff'
                            object.rotatingPointOffset = 20
                            object.transparentCorners = false
                            object.uniScaleTransform = true
                            object.selectionBackgroundColor = 'rgba(210,210,210,0.2)'
                        }

                        if (object.custom.name === 'Trim Area' || object.custom.name === 'Safe Area' || this.$store.state.mode === 'designer') { // || object.custom.editable === false || object.custom.editable === true
                            // Design Mode - Set all objects to non selectable and hide controls if it's not an image
                            if (object.type !== 'image') {
                                object.selectable = false
                                object.editable = false
                                object.setControlsVisibility({ bl: false, br: false, mb: false, ml: false, mr: false, mt: false, tl: false, tr: false, mtr: false })
                            } else if (object.custom.locked === true) {
                                object.selectable = false
                            }

                            // Assign safe and trim targets
                            if (object.custom.name === 'Trim Area') {
                                this.trimObject = object
                            } else if (object.custom.name === 'Safe Area') {
                                this.safeObject = object
                            }
                        }

                        if (object.type === 'image' && !object.custom.uploadButton) {
                            object.custom.uploadButton = 'Select Image File'
                        }

                        if (!object.custom.data_attribute) {
                            object.custom.data_attribute = ''
                        } else {
                            if (object.custom.data_attribute !== '' && this.$store.state.mode === 'designer') {
                                // Add Injection Code Here
                                if (object.custom.data_attribute.includes('standard.')) {
                                    let attribute = object.custom.data_attribute.replace('standard.', '')
                                    if (this.$auth.user().data_attributes.standard && this.$auth.user().data_attributes.standard[attribute]) {
                                        object.text = this.$auth.user().data_attributes.standard[attribute]
                                    }
                                    object.setCoords()
                                    this.canvas.renderAll()
                                } else if (object.custom.data_attribute.includes('vendor.')) {
                                    let attribute = object.custom.data_attribute.replace('vendor.', '')
                                    if (this.$auth.user().data_attributes.vendor && this.$auth.user().data_attributes.vendor[attribute]) {
                                        object.text = this.$auth.user().data_attributes.vendor[attribute]
                                    }
                                    object.setCoords()
                                    this.canvas.renderAll()
                                }
                            }
                        }

                        if (object.custom.editable === true) {
                            editableLayers = true
                        }
                    } else {
                        object.custom = {
                            name: null,
                            mask: null,
                            confirmed: false,
                            data_attribute: ''
                        }
                    }

                    // Design Mode
                    // if (this.$store.state.mode === 'designer') {
                    //     editableLayers = true
                    // }

                    // Force caching off for all text areas
                    if (object.type === 'textbox') {
                        object.caching = false
                    }
                })
            }
        },
        toggleShortcuts: function () {
            this.shortcuts = !this.shortcuts
        },
        setTooltip: function (index) {
            let tips = [
                'Left align selected objects', // 0
                'Center align selected objects',
                'Right align selected objects',
                'Vertical align selected objects to the top',
                'Vertical align selected objects to the bottom',
                'Move layer to the very top',
                'Move layer up one position',
                'Move layer down one position',
                'Move layer to the very bottom',
                'Add new object to the canvas',
                'Delete selected object', // 10
                'Lock editing of layer so customers cannot make changes',
                'Hide layer',
                'Lock layer',
                'Set font to italic',
                'Set font to bold',
                'Set font to underlined',
                'Left align text',
                'Center text',
                'Right align text',
                'Justify text', // 20
                'Duplicate this layer',
                'Trim area is calculated based on bleed set by the template.',
                'Safe area is calculated based on bleed settings',
                'Flip layer horizontally',
                'Flip layer vertically ',
                'Center objects vertically',
                'Distribute objects horizontally',
                'Distribute objects vertically',
                'Flip selected object horizontally',
                'Flip selected object vertically', // 30
                'Automatically scale the font to fit the textbox',
                'Toggle "Small Caps"'
            ]
            this.tooltip = (this.tooltip === tips[index]) ? null : tips[index]
        },
        loadFonts (googleFamilies = null, loadFamilies = null, loadUrls = null, wait = true) {
            let fontConfig = {}

            if (googleFamilies !== null && googleFamilies.length > 0) {
                fontConfig.google = { families: googleFamilies }
            }
            if (loadFamilies !== null && loadFamilies.length > 0) {
                fontConfig.custom = {
                    families: loadFamilies,
                    urls: loadUrls
                }
            }

            fontConfig.active = () => {
                if (wait === true) {
                    this.loadingComplete = true
                    this.canvas.renderAll()
                } else {
                    this.canvas.renderAll()
                }
            }

            WebFont.load(fontConfig)
        }
    },
    /**
     * Fired before mounting of the component
     * @return {void}
     */
    beforeMount () {
        this.loadingStatus = 'Initializing..'

        this.windowMsgScrollToIframe()
        this.windowMsgLockWindow(true)

        // Setup Product Dimensions & Bleed
        this.productWidth = parseFloat(this.prodWidth)
        this.productHeight = parseFloat(this.prodHeight)
        this.currentTrim = parseFloat(this.prodBleed)
        this.currentSafe = parseFloat(this.prodSafe)
        this.productPixelWidth = (this.productWidth + (this.currentTrim * 2)) * 300
        this.productPixelHeight = (this.productHeight + (this.currentTrim * 2)) * 300

        // Set Active Tab > Triggers activeTemplate watcher
        let set = this.$store.state.activeTemplate
        let files = this.$store.state.template.files
        Object.keys(files).forEach((key) => {
            if (set === null) {
                this.$store.commit('activeTemplate', key)
                set = key
            }
        })

        this.loadingStatus = 'Building Template'

        /* Fetch Font List */
        /* --------------- */
        let activeFonts = []
        Object.keys(files).forEach((key) => {
            if (files[key].fonts !== undefined && files[key].fonts.length > 0) {
                for (let i in files[key].fonts) {
                    activeFonts.push(files[key].fonts[i])
                }
            }
        })
        this.$store.commit('activeFonts', activeFonts)

        if (this.$store.state.fontsLoadedFor !== this.$store.state.template.id) {
            this.axios.get('/fonts/list?limit=500')
            .then((response) => {
                this.loadingStatus = 'Loading Fonts'

                let fonts = response.data.data
                let loadFamilies = []
                let loadUrls = []
                let googleFamilies = []

                for (var i in fonts) {
                    if (_.includes(activeFonts, fonts[i].name) || this.displayType === 'editor') {
                        loadFamilies.push(fonts[i].name)
                        loadUrls.push(fonts[i].css)
                    }
                }
                if (this.displayType === 'editor') {
                    fonts.unshift({name: 'Custom Fonts:'}, {name: '-----------------------'})
                }

                // Google Font
                this.axios.get('https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyAKgDGIZYO2npQx6c894aC1lkRUidSRwa8')
                .then((response) => {
                    let title2 = false
                    for (var i in response.data.items) {
                        if (_.includes(activeFonts, response.data.items[i].family) || this.displayType === 'editor') {
                            if (title2 === false && this.displayType === 'editor') {
                                title2 = true
                                fonts.push({name: ''})
                                fonts.push({name: 'Google Fonts:'})
                                fonts.push({name: '-----------------------'})
                            }
                            fonts.push({name: response.data.items[i].family})
                            if (_.includes(activeFonts, response.data.items[i].family)) {
                                googleFamilies.push(response.data.items[i].family)
                            }
                        }
                    }

                    if ((googleFamilies !== null && googleFamilies.length > 0) || (loadFamilies !== null && loadFamilies.length > 0)) {
                        this.loadFonts(googleFamilies, loadFamilies, loadUrls)
                        this.$store.commit('fonts', fonts)
                        this.$store.commit('fontsLoadedFor', this.$store.state.template.id)
                    } else {
                        this.loadingComplete = true
                        this.canvas.renderAll()
                    }
                })
            })
        } else {
            this.loadingComplete = true
        }

        this.dataAttributes.push('standard.first_name', 'standard.last_name', 'standard.full_name', 'standard.email', 'standard.company', 'standard.work_phone', 'standard.cell_phone', 'standard.fax', 'standard.address1', 'standard.address2', 'standard.city', 'standard.state', 'standard.zip', 'standard.country')
        if (this.$store.state.template.hasOwnProperty('vendors') && this.$store.state.template.vendors.data.length > 0) {
            this.dataAttributes.push('# Vendor Data Attributes ----------')
            for (var key in this.$store.state.template.vendors.data[0].data_attributes.vendor) {
                this.dataAttributes.push('vendor.' + key.replace('vendor.', ''))
            }
        }
    },
    /**
     * Fired once the component is mounted
     * @return {void}
     */
    mounted () {
        fabric.Object.prototype.objectCaching = false
        // Default Style for Group Selection
        fabric.Object.prototype.padding = 8
        fabric.Object.prototype.cornerSize = 14
        fabric.Object.prototype.cornerStyle = 'circle'
        fabric.Object.prototype.cornerColor = '#76C15D'
        fabric.Object.prototype.cornerStrokeColor = '#ffffff'
        fabric.Object.prototype.rotatingPointOffset = 20
        fabric.Object.prototype.transparentCorners = false
        fabric.Object.prototype.uniScaleTransform = true
        fabric.Object.prototype.selectionBackgroundColor = 'rgba(210,210,210,0.2)'
        // fabric.Object.prototype.noScaleCache

        fabric.Textbox.prototype.setFontSize = function (size) {
            this.fontSize = fabric.util.parseUnit(size)
            return this
        }
        fabric.Textbox.prototype.scaleFontSize = function () {
            this.canvas.renderAll()

            let lineWidth = getLineWidth(this)
            let charWidth = getCharWidth(this, lineWidth)
            var tryWidth = (lineWidth * this.scaleX) + charWidth

            if (tryWidth > this.custom.maxWidth) {
                scaleDown(this, tryWidth)
            } else if ((this.fontSize * (this.custom.maxWidth / (this.width - 1))) < this.custom.fontSize) {
                scaleUp(this)
            }

            function getLineWidth (text) {
                let lineWidth = 0
                for (let i in text.__lineWidths) {
                    lineWidth += text.__lineWidths[i]
                }
                return lineWidth
            }

            function getCharWidth (text, lineWidth) {
                let textLength = (text.text.length > 1) ? (text.text.length) : 2
                return lineWidth / textLength
            }

            function scaleDown (text, currentWidth) {
                let maxWidth = text.custom.maxWidth
                text.fontSize *= maxWidth / currentWidth
                text.width = maxWidth

                text.canvas.renderAll()

                let lineWidth = getLineWidth(text)
                charWidth = getCharWidth(text, lineWidth)
                tryWidth = (lineWidth * text.scaleX) + charWidth

                if (tryWidth > text.custom.maxWidth) {
                    scaleDown(text, tryWidth)
                }
            }

            function scaleUp (text) {
                text.fontSize *= text.custom.maxWidth / (text.width - 1)

                if (text.fontSize < text.custom.fontSize) {
                    text.fontSize = text.custom.fontSize
                    text.canvas.renderAll()

                    lineWidth = getLineWidth(text)
                    charWidth = getCharWidth(text, lineWidth)
                    tryWidth = (lineWidth * text.scaleX) + charWidth
                    if (tryWidth > text.custom.maxWidth) {
                        scaleDown(text, tryWidth)
                    }
                }
            }

            if (!this.custom.lastHeight) {
                this.custom.lastHeight = this.custom.maxHeight
            }

            let adjustHeight = 0
            if (this.height < this.custom.lastHeight) {
                adjustHeight = this.custom.maxHeight - this.height
            } else {
                adjustHeight = this.custom.maxHeight - this.height
            }
            this.top = this.custom.topOffset + (adjustHeight / 2)
            this.custom.lastHeight = this.height

            return this
        }
        fabric.DPI = 300

        this.canvas = new fabric.Canvas('canvas')
        this.canvas.preserveObjectStacking = false

        window.addEventListener('resize', this.resizeCanvas, false)

        this.canvasData = this.canvas.getObjects()

        // Watch for objects added to the canvas
        this.canvas.on('object:added', (e) => {
            if (e.target.custom !== undefined && e.target.custom.name === 'Trim Area') {
                this.trimObject = e.target
            } else if (e.target.custom !== undefined && e.target.custom.name === 'Safe Area') {
                this.safeObject = e.target
            }
        })

        // Watch for canvas object selection to toggle accordion
        this.canvas.on('object:selected', (options) => {
            let parnt = this
            let idx = this.canvasDataReverse.indexOf(options.target)
            if (this.selected !== idx || $('a[href=#collapse' + idx + ']').attr('aria-expanded') !== 'true' && this.loadingComplete === true) {
                $('a[href=#collapse' + idx + ']').trigger('click')
                parnt.selected = idx
                // Scroll the page to the active object after it has settled
                if (this.loadingComplete === true) {
                    window.scroll({
                        top: options.target.top - (window.innerHeight / 2),
                        left: 0,
                        behavior: 'smooth'
                    })
                }
            }
        })

        this.canvas.on('selection:created', (e) => {
            let obj = e.target._objects[0]

            if (this.displayType === 'designer') {
                this.canvas.discardActiveGroup().setActiveObject(obj).renderAll()
            }
        })

        this.canvas.on('object:moving', function (options) {
            if (options.e.shiftKey === true) {
                options.target.lockMovementX = true
            } else if (options.e.altKey === true) {
                options.target.lockMovementY = true
            }
        })

        this.canvas.on('object:rotating', (options) => {
            this.$store.commit('templateChanges', true)

            this.tooltip = 'Hold shift to enable snap'
            if (options.e.shiftKey === true) {
                options.target.snapAngle = 22.5
            } else {
                options.target.snapAngle = 0
            }
        })

        this.canvas.on('mouse:up', (options) => {
            if (this.canvas.getActiveObject() === null) {
                $('a[aria-expanded=true]').trigger('click')
                this.selected = null
            }
        })

        this.canvas.on('object:removed', (options) => {
            this.$store.commit('templateChanges', true)
        })

        this.canvas.on('object:modified', (options) => {
            this.$store.commit('templateChanges', true)

            this.tooltip = null
            if (options.target.custom !== undefined && options.target.custom.locked !== true) {
                options.target.lockMovementX = false
                options.target.lockMovementY = false
            }

            // Reset our autoscale info if autoscaling is turned on for this element
            if (options.target.custom.autoscale === true) {
                options.target.custom.maxWidth = options.target.width
                options.target.custom.maxHeight = options.target.height
                options.target.custom.topOffset = options.target.top
            }

            options.target.setCoords()
            this.canvas.renderAll()
        })
        // this.canvas.on('after:selection:cleared', function (options) {
        //     console.log(this.canvas.getActiveObject())
        //     var idx = this.canvas.getObjects().indexOf(options.target)
        //     console.log(idx)
        //     console.log(this.selected)
        //     if (this.selected !== idx) {
        //         $('a[href=#collapse' + idx + ']').trigger('click')
        //         this.selected = idx
        //     }
        // })

        // this.canvas.on('mouse:over', function (e) {
        //     e.target.set('active', true)
        //     this.canvas.renderAll()
        // })

        // this.canvas.on('mouse:out', function (e) {
        //     e.target.set('active', false)
        //     this.canvas.renderAll()
        // })

        // Watch Object Resizing
        this.canvas.on('object:scaling', (e) => {
            let obj = e.target
            // Check Stroke Scaling
            if (!obj.strokeWidthUnscaled && obj.strokeWidth) {
                obj.strokeWidthUnscaled = obj.strokeWidth
            }
            if (obj.strokeWidthUnscaled) {
                obj.strokeWidth = obj.strokeWidthUnscaled / obj.scaleX
            }
            // Stop Images from being Upscaled to anything higher than 1x
            if (obj.get('type') === 'image') {
                if (obj.scaleX > 1) {
                    obj.scaleX = 1
                }
                if (obj.scaleY > 1) {
                    obj.scaleY = 1
                }
            }
        })

        // Watch Page Scrolling to Lock the Canvas Position
        window.addEventListener('scroll', function () {
            if (window.pageYOffset >= 78 && $(window).width() >= 768) {
                $('.secondary-nav').addClass('fixed')
                $('.layers').addClass('fixed')
                $('.artboard').addClass('fixed')

                let activeLayerTop = $('.layers').offset()
                if (activeLayerTop !== undefined) {
                    if (window.pageYOffset >= (activeLayerTop.top - 80)) {
                        $('.layers').addClass('fixed')
                    }
                }
            } else {
                $('.fixed').removeClass('fixed')
            }
        })

        if (this.displayType === 'editor') {
            //
        } else if (this.displayType === 'preview') {
            //
        }

        if (this.$store.state.template !== null) {
            this.canvasLoad()
        } else {
            this.canvasInit()
        }

        this.resizeCanvas(null)
    },
    /**
     * Fired when the component is created
     * @return {void}
     */
    created () {
        if (this.$store.state.savedTemplate === null) {
            this.newTemplate = true
            this.templateName = new Date().getUTCMilliseconds()
        }

        // Watch for activeTemplate to change so we can swap out the loaded template
        this.watcher = this.$store.watch((state) => state.activeTemplate, (newValue, oldValue) => {
            this.templateTransition = true
            this.generateImage(oldValue)

            // Confirm that a different template was selected / else do nothing
            if (newValue !== oldValue) {
                Object.keys(this.$store.state.template.files).forEach((key) => {
                    // Save our current template out so we don't lose changes when switching
                    if (key === oldValue) {
                        let template = this.$store.state.template

                        // Unclip All Masks
                        for (let i in this.canvasData) {
                            if (this.canvasData[i].clipTo !== null) {
                                this.canvasData[i].clipTo = null
                            }
                        }

                        // Set Template Confirmation Status
                        if (this.checkConfirmed()) {
                            template.files[key].confirmed = true
                        }
                        template.files[key].json = this.canvas.toDatalessJSON(['custom'])
                        this.$store.commit('template', template)
                        this.$store.commit('activeTemplate', newValue)
                        this.templateTransition = false
                    }
                })

                // Load Selected Template Side
                setTimeout(() => {
                    this.canvasLoad(newValue)
                }, ((oldValue === null) ? 500 : 0))
                this.canvas.renderAll()
            }
        })
    },
    /**
     * Fired before the component is destroyed in the vue workflow
     * @return {void}
     */
    beforeDestroy () {
        // Unset the activeTemplate
        this.$store.commit('activeTemplate', null)
        this.watcher()
    },
    /**
     * Directives for the component
     * @type {Object}
     */
    directives: {
        insertMessage: function (canvasElement, binding) {
            // Get canvas context
            // var ctx = canvasElement.getContext('2d')
            // ctx.fillStyle = 'orange'
            // // Clear the canvas
            // ctx.clearRect(0, 0, 650, 400)
            // // Insert stuff into canvas
            // ctx.fillStyle = 'black'
            // ctx.font = '20px Helvetica'
            // ctx.fillText(binding.value, 10, 50)
        }
    },
    /**
     * Filters for the component
     * @type {Object}
     */
    filters: filters
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @-webkit-keyframes spin {
        0%  {-webkit-transform: rotate(0deg);}
        100% {-webkit-transform: rotate(360deg);}
    }

    .loadingBlock {
        height: auto;
        z-index: 99999;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #FFFFFF;

        div.center-align-ab {
            font-size: 1.3em;
            padding-left: 1.7em;
            color: #000000;
            margin-top: -75px;
            top: 200px !important;
        }
    }
    .canvasBlock {
        /*display: none;*/
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// Canvas.vue?9ad87618